import { gql } from '@apollo/client';

import { CollaborationToolType, useCollaborationServiceIntegrationsQuery } from 'src/generated/mloop-graphql';

import CodeSignalService from './CodeSignalService';
import CoderpadService from './CoderPadService';
import CodilityService from './CodilityService';
import HackerRankService from './HackerRankService';

const getCollaborationService = (collaborationType: CollaborationToolType) => {
  switch (collaborationType) {
    case CollaborationToolType.Coderpad:
      return CoderpadService;
    case CollaborationToolType.Codesignal:
      return CodeSignalService;
    case CollaborationToolType.Codility:
      return CodilityService;
    case CollaborationToolType.Hackerrank:
      return HackerRankService;
    default:
      return null;
  }
};

const useCurrentOrgCollaborationToolType = (): CollaborationToolType | null => {
  const { data: integrations } = useCollaborationServiceIntegrationsQuery();

  if (!integrations) {
    return null;
  }

  if (integrations?.thisOrg?.integrations?.coderpad) {
    return CollaborationToolType.Coderpad;
  }
  if (integrations?.thisOrg?.integrations?.codility) {
    return CollaborationToolType.Codility;
  }
  if (integrations?.thisOrg?.integrations?.codesignal) {
    return CollaborationToolType.Codesignal;
  }
  if (integrations?.thisOrg?.integrations?.hackerrank) {
    return CollaborationToolType.Hackerrank;
  }

  return null;
};

const useOrgCollaborationService = () => {
  const collaborationType = useCurrentOrgCollaborationToolType();
  if (!collaborationType) {
    return null;
  }
  return getCollaborationService(collaborationType);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useOrgCollaborationServiceQuery = gql`
  query CollaborationServiceIntegrations {
    thisOrg {
      integrations {
        id
        coderpad {
          apiKey
        }
        codility {
          apiKey
        }
        codesignal {
          apiKey
        }
        hackerrank {
          apiKey
        }
      }
      id
    }
  }
`;

export { useOrgCollaborationService, getCollaborationService };
